(function () {
  function plural(n) { return n === 1 ? "" : "s"; }

  function refreshGoal() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(r => r.json())
      .then(cart => {
        const root = document.getElementById("nz-cart-goal-root");
        if (!root) return;

        const wrapper = root.querySelector(".nz-cart-goal");
        if (!wrapper) return; // skeleton must exist from liquid

        const textEl = root.querySelector(".nz-cart-goal__text");
        const fillEl = root.querySelector(".nz-cart-goal__singlebar-fill");

        const count = cart.item_count || 0;
        const goal15 = 2;
        const goal20 = 3;

        // Hide when empty
        if (count <= 0) {
          wrapper.classList.add("nz-cart-goal--hidden");
          return;
        } else {
          wrapper.classList.remove("nz-cart-goal--hidden");
        }

        const remaining15 = Math.max(0, goal15 - count);
        const remaining20 = Math.max(0, goal20 - count);
        const progress = Math.min(100, (count / goal20) * 100);

        if (fillEl) fillEl.style.width = progress + "%";

        if (textEl) {
          if (count < goal15) {
            textEl.innerHTML =
              `Add <strong>${remaining15}</strong> more item${plural(remaining15)} to unlock <strong>15% off</strong>.` +
              ` <span class="nz-cart-goal__sub">Add <strong>${remaining20}</strong> more for <strong>20% off</strong> (3+ items).</span>`;
          } else if (count < goal20) {
            textEl.innerHTML =
              `<strong>15% off unlocked.</strong>` +
              ` <span class="nz-cart-goal__sub">Add <strong>${remaining20}</strong> more item${plural(remaining20)} to unlock <strong>20% off</strong>.</span>`;
          } else {
            textEl.innerHTML = `<strong>20% off unlocked.</strong> ✨`;
          }
        }
      })
      .catch(() => {});
  }

  function scheduleRefresh() {
    window.clearTimeout(window.__nzGoalTimer);
    window.__nzGoalTimer = window.setTimeout(refreshGoal, 350);
  }

  // Most cart interactions in drawer are clicks/changes; refresh shortly after
  document.addEventListener("click", function (e) {
    if (!e.target.closest("#CartDrawer")) return;
    scheduleRefresh();
  });

  document.addEventListener("change", function (e) {
    if (!e.target.closest("#CartDrawer")) return;
    scheduleRefresh();
  });

  // Also refresh when drawer opens (Impulse commonly toggles aria-hidden/classes)
  document.addEventListener("DOMContentLoaded", function () {
    refreshGoal();
  });

})();
